import React from 'react';
import { AllhomesCheckboxList } from '@domain-group/fe-co-allhomes-checkbox-list';
import * as styles from './list-filter.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ALL_THRESHOLD = 5;
export var ListFilter = _ref => {
  var title = _ref.title,
    name = _ref.name,
    _ref$available = _ref.available,
    available = _ref$available === void 0 ? [] : _ref$available,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    _ref$twoColumn = _ref.twoColumn,
    twoColumn = _ref$twoColumn === void 0 ? false : _ref$twoColumn,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange;
  return available.length ? ___EmotionJSX("div", {
    css: styles.filter
  }, ___EmotionJSX("div", {
    css: styles.title
  }, title), ___EmotionJSX(AllhomesCheckboxList, {
    css: twoColumn ? styles.twoColumn : styles.oneColumn,
    available: available.map(_ref2 => {
      var value = _ref2.name,
        label = _ref2.label,
        isNew = _ref2.isNew;
      return {
        label,
        value,
        isNew
      };
    }),
    selected: selected,
    onChange: value => _onChange({
      [name]: value
    }),
    all: available.length < ALL_THRESHOLD ? 'none' : 'none-is-all'
  })) : ___EmotionJSX("div", null);
};